'use client'

import Link from 'next/link'
import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'

export function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Check if cookie consent has been given
    const hasConsent = document.cookie
      .split('; ')
      .find(row => row.startsWith('aviso_cookie='))

    if (!hasConsent) {
      setIsVisible(true)
    }
  }, [])

  const handleAccept = () => {
    // Set cookie for 50 years
    const expiryDate = new Date()
    expiryDate.setFullYear(expiryDate.getFullYear() + 50)

    document.cookie = `aviso_cookie=1; expires=${expiryDate.toUTCString()}; path=/; domain=${window.location.hostname}`

    setIsVisible(false)
  }

  if (!isVisible) return null

  return (
    <div className="fixed right-0 bottom-0 left-0 z-[9999999999999999999999999999999999] p-4 md:p-8">
      <div className="mx-auto max-w-7xl">
        <div className="relative rounded-lg border-2 border-[#2d2861] bg-white p-5 shadow-lg">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:gap-6">
            <div className="flex-1 text-black text-sm md:text-base">
              <p className="m-0 text-justify">
                🍪 Ao utilizar nossa plataforma você concorda em melhorarmos a
                sua experiência e navegação por meio de cookies. <br /> Saiba
                mais em nossa{' '}
                <Link
                  className="text-[#2d2861] underline hover:no-underline"
                  href="/politica-de-privacidade"
                  target="_blank"
                >
                  Política de Privacidade.
                </Link>
              </p>
            </div>
            <div className="shrink-0">
              <Button
                className="w-full bg-[#2d2861] text-white hover:bg-[#2d2861]/90 md:w-auto"
                onClick={handleAccept}
                size="sm"
              >
                OK, FECHAR AVISO
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
